import * as Yup from "yup";

export const MaintenanceScheduleAffectedChecksSchema = Yup.object({
  affected_checks: Yup.array()
    .of(
      Yup.object({
        id: Yup.number().required(),
      })
    )
    .defined(),
});

export const MaintenanceScheduleAffectedChecksDefaultValues = {
  affected_checks: [],
};
